// LandingPage.js
import React, { useEffect, useState} from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Typography, Grid, Avatar, Button, Box, Container, Divider, Drawer, List, ListItem, ListItemButton, ListItemText, CircularProgress, Paper } from '@mui/material';
import { Link as ExternalLink } from '@mui/material';
//import TwitterIcon from '@mui/icons-material/Twitter';
import DescriptionIcon from '@mui/icons-material/Description'; // For CV
//import SchoolIcon from '@mui/icons-material/School';
import MenuIcon from '@mui/icons-material/Menu';
//import group from './nathoo.jpeg'
import logo from './images/logo.webp'
import "react-photo-album/masonry.css";
import PhotoGallery from './components/PhotoGallery';
import LazyImage from './components/LazyImage';
//import up from './up.jpg'
import spat from './images/spat.webp'
import fn from './images/nathoo.webp'
import victoria from './images/victoria.png';
import bayes from './images/bayes.webp'
import high from './images/high.webp'
import nserc from './NSERC_RGB.svg'
import math from './images/math.webp'
import cihr from './images/cihr.webp'
import uvic from './images/uvic.webp'
import tfri from './images/tfri.webp'
import biostat from './images/biostat.png'
// Removed unused swiper CSS imports

// import required modules

import { fetchCV, fetchAnnouncements, isContentfulConfigured } from './services/contentful';

// Lazy load components for code splitting
const BioGallery = React.lazy(() => import('./Biogallery'));

const formatAnnouncementDate = (d) => {
  if (!d) return '';
  const date = typeof d === 'string' ? new Date(d) : d;
  return isNaN(date.getTime()) ? d : date.toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' });
};

const AnnouncementBanner = React.memo(() => {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    const load = async () => {
      if (isContentfulConfigured()) {
        const data = await fetchAnnouncements();
        const latest = data.find(a => a.announcement?.trim());
        if (latest) setAnnouncement(latest);
      }
    };
    load();
  }, []);

  if (!announcement) return null;

  return (
    <Box sx={{ backgroundColor: '#f0f4f8', py: 1.5, px: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
      <Container maxWidth="lg">
        <Typography variant="body2" sx={{ color: '#444', textAlign: 'center' }}>
          {announcement.date && (
            <Box component="span" sx={{ fontWeight: 600, mr: 1 }}>
              {formatAnnouncementDate(announcement.date)}:
            </Box>
          )}
          {announcement.announcement}
        </Typography>
      </Container>
    </Box>
  );
});

const AnnouncementsSidebar = React.memo(() => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const load = async () => {
      if (isContentfulConfigured()) {
        const data = await fetchAnnouncements();
        setAnnouncements(data.slice(0, 5).filter(a => a.announcement?.trim()));
      }
    };
    load();
  }, []);

  if (announcements.length === 0) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: '#f8f8f8',
        borderRadius: 2,
        position: { xs: 'relative', md: 'sticky' },
        top: { md: 72 },
        minWidth: 280,
        maxWidth: 320,
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
        Announcements
      </Typography>
      {announcements.map((a) => (
        <Box key={a.id} sx={{ mb: 1.5, '&:last-child': { mb: 0 } }}>
          {a.date && (
            <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', color: 'text.secondary' }}>
              {formatAnnouncementDate(a.date)}
            </Typography>
          )}
          <Typography variant="body2" sx={{ color: '#444' }}>
            {a.announcement}
          </Typography>
        </Box>
      ))}
    </Paper>
  );
});
const SoftwarePage = React.lazy(() => import('./SoftwarePage'));
const Pubpage = React.lazy(() => import('./Pubpage'));

const Slideshow = React.memo(() => {
  return (
    <Box
      sx={{
        width: '100%',
        height: 'calc(100vh - 120px)', // Fill remaining viewport below header + announcement
        minHeight: 360,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={victoria}
        alt="Victoria waterfront and Fairmont Empress Hotel"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    </Box>
  );
});


const PISection = React.memo(() => {
  const [cvData, setCvData] = useState(null);
  const [loadingCV, setLoadingCV] = useState(true);

  // Animation replaced with CSS for better performance

  // Load CV from Contentful
  useEffect(() => {
    const loadCV = async () => {
      setLoadingCV(true);
      try {
        if (isContentfulConfigured()) {
          const cv = await fetchCV();
          setCvData(cv);
        }
      } catch (error) {
        console.error('Error loading CV:', error);
      } finally {
        setLoadingCV(false);
      }
    };

    loadCV();
  }, []);

  // Determine CV URL - use Contentful if available, otherwise fallback
  const cvUrl = cvData?.url;
  const cvButtonText = 'CV';

  return (
    <Box sx={{ mb: 3, maxWidth: 880, mx: 'auto' }}>
      <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 700, mb: 2 }}>
        Meet Our Principal Investigator
      </Typography>
      <Grid container spacing={3} alignItems="center" justifyContent="center">
        <Grid item xs={12} md={4} textAlign="center">
          <Avatar
            src={fn}
            alt="PI Image"
            variant="rounded"
            sx={{ width: 200, height: 200, margin: 'auto', borderRadius: 2 }}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5 }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Dr. Farouk Nathoo, PhD
            </Typography>
            {loadingCV ? (
              <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, color: 'text.secondary', fontSize: '0.875rem' }}>
                <CircularProgress size={14} color="inherit" /> {cvButtonText}
              </Box>
            ) : cvUrl ? (
              <ExternalLink
                href={cvUrl}
                target="_blank"
                rel="noopener"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  color: 'primary.main',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                <DescriptionIcon sx={{ fontSize: 18 }} /> {cvButtonText}
              </ExternalLink>
            ) : null}
          </Box>
          <Typography variant="body1" sx={{ color: '#555', lineHeight: 1.6, mt: 1 }}>
            Dr. Nathoo is Professor of Statistics in the Department of Mathematics and Statistics at the University of Victoria. His research interests have emphasis on biostatistics and Bayesian methods broadly with specific emphasis on the analysis of spatial, temporal and spatiotemporal data. His teaching interests have emphasis on interdisciplinary training of graduate students, Bayesian statistics and data analysis.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
});
const OrganizationLogos = () => {
  const logos = [
    { image: nserc, name: 'Organization 1' },
    { image: cihr, name: 'Organization 2' },
    { image: tfri, name: 'Organization 3' },
    { image: uvic, name: 'Organization 4' },
    { image: math, name: 'Organization 5' },
  ];
  return (
    <Paper elevation={0} sx={{ p: 2, mb: 2, backgroundColor: '#f8f8f8', borderRadius: 2 }}>
      <Grid container spacing={2} justifyContent="center">
        {logos.map((logo, index) => (
          <Grid item xs={6} sm={6} md={2} key={index}>
            <Box sx={{ textAlign: 'center', p: 1 }}>
              <LazyImage
                src={logo.image}
                alt={logo.name}
                sx={{
                  width: '100%',
                  maxWidth: '300px',
                  height: 'auto',
                  objectFit: 'contain',
                  marginBottom: '1rem',
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

const ResearchInterests = React.memo(() => {
  const interests = [
    { title: 'Bayesian Statistics', description: 'Integrating Prior Information; Hierarchical Modelling; Probabilistic Interpretations', image: bayes },
    { title: 'Biostatistics', description: 'Solving statistical problems, developing new modelling and computational methods and analyzing data motivated by biological and medical research towards advancing human health.', image: biostat },
    { title: 'High Dimensional Statistics', description: 'More unknown parameters than number of data points.', image: high },
    { title: 'Spatial Statistics', description: 'The analysis of data with a location attribute. These could be geographical areas (disease mapping; brain mapping), point locations (trees), random locations (cell locations on a tissue sample; animal movements).', image: spat },
  ];

  return (
    <Paper elevation={0} sx={{ p: 2, mb: 2, backgroundColor: '#fafafa', borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 700, mb: 1 }}>
        Our Research Interests
      </Typography>
      <Typography variant="body2" sx={{ color: '#555', textAlign: 'center', mb: 2, maxWidth: 720, mx: 'auto' }}>
        Our group has primary interests in biostatistics and Bayesian methods broadly with specific emphasis on the analysis of spatial, temporal and spatiotemporal data, including neuroimaging data and spatial omics data. Application areas include neurodegenerative disorders (Alzheimer's disease, Attention-deficit/hyperactivity disorder) and cancer (ovarian cancer).
      </Typography>
      <Grid container spacing={2}>
        {interests.map((interest, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Paper elevation={0} sx={{ p: 1.5, height: '100%', backgroundColor: '#fff', borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                <LazyImage src={interest.image} alt={interest.title} sx={{ width: 120, height: 120, objectFit: 'contain', opacity: 0.85, borderRadius: 2 }} />
              </Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, textAlign: 'center' }}>{interest.title}</Typography>
              <Typography variant="body2" sx={{ color: '#555', mt: 0.5, textAlign: 'center' }}>{interest.description}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
});


const NavButton = ({ to, children, ...props }) => (
  <Button
    color="inherit"
    component={Link}
    to={to}
    sx={{
      fontWeight: 700,
      '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' },
      ...props.sx,
    }}
    {...props}
  >
    {children}
  </Button>
);

const Header = React.memo(() => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <List>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/">
            <ListItemText primary="Home" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/publications">
            <ListItemText primary="Publications" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/software">
            <ListItemText primary="Software" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/team">
            <ListItemText primary="Team" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/join-us">
            <ListItemText primary="Join Us" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
      <ListItemButton
        component="a"
        href="https://flxp0x-puneet-velidi.shinyapps.io/bayesfactor/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ListItemText primary="eJAB Calculator" />
      </ListItemButton>
    </ListItem>

      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="sticky" sx={{ backgroundColor: '#000000', boxShadow: 'none' }}>
        <Toolbar>
          {/* Logo and Title */}
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <img
              src= {logo} // Replace with actual logo URL
              alt="Lab Logo"
              style={{ width: 40, height: 40, marginRight: '10px' }}
            />
      <Link to="/" style={{ textDecoration: 'none', color: 'inherit', fontSize: 20, fontWeight: 700}}>
        Nathoo
        Group
      </Link>
          </Box>

          {/* Desktop Navigation */}
          <Box sx={{ display: { xs: 'none', md: 'block' }, fontWeight: 700 }}>
            <NavButton to="/" aria-current={location.pathname === '/' ? 'page' : undefined}>Home</NavButton>
            <NavButton to="/publications" aria-current={location.pathname === '/publications' ? 'page' : undefined}>Publications</NavButton>
            <NavButton to="/software" aria-current={location.pathname === '/software' ? 'page' : undefined}>Software</NavButton>
            <NavButton to="/team" aria-current={location.pathname === '/team' ? 'page' : undefined}>Team</NavButton>
            <NavButton to="/join-us" aria-current={location.pathname === '/join-us' ? 'page' : undefined}>Join Us</NavButton>
            <Button color="inherit" href="https://flxp0x-puneet-velidi.shinyapps.io/bayesfactor/" target="_blank" rel="noopener noreferrer" sx={{ fontWeight: 700, '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' } }}>
              eJAB Calculator
            </Button>
          </Box>

          {/* Mobile Navigation */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
            sx={{ display: { xs: 'block', md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
});



const footerLinkSx = { color: 'inherit', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } };

const Footer = React.memo(() => {
  const location = useLocation();

  return (
    <Box sx={{ backgroundColor: '#000000', color: '#fff', padding: '2rem 0', marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
      <Container>
        <Typography variant="body1" align="center" sx={{ fontWeight: 400 }}>
          <ExternalLink href="https://www.uvic.ca/science/math-statistics/index.php" sx={footerLinkSx}>
            Department of Mathematics and Statistics,
          </ExternalLink>{' '}
          <ExternalLink href="https://www.uvic.ca/" sx={footerLinkSx}>
            University of Victoria
          </ExternalLink>
        </Typography>
        <Typography variant="body2" align="center" sx={{ color: '#ccc' }}>
          David Turpin Building A418{location.pathname !== '/join-us' && ' | nathoo at uvic dot ca'}
        </Typography>
        <Typography variant="body2" align="center" sx={{ color: '#ccc' }}>
          <ExternalLink href="https://www.uvic.ca/info-for/indigenous/index.php" sx={footerLinkSx}>
            We acknowledge and respect the Lək̓ʷəŋən (Songhees and Esquimalt) Peoples on whose territory the university stands, and the Lək̓ʷəŋən and W̱SÁNEĆ Peoples whose historical relationships with the land continue to this day.
          </ExternalLink>
        </Typography>
      </Container>
    </Box>
  );
});


function App() {
  const [appLoading, setAppLoading] = useState(true);

  useEffect(() => {
    const onLoad = () => setAppLoading(false);
    window.addEventListener('load', onLoad);
    const t = setTimeout(() => setAppLoading(false), 1500);
    return () => {
      window.removeEventListener('load', onLoad);
      clearTimeout(t);
    };
  }, []);

  return (
    <>
      {/* Page loader overlay using public/logo512.png */}
      <style>{`
        @keyframes pulseLogo { 0% { transform: scale(0.85);} 50% { transform: scale(1.1);} 100% { transform: scale(0.85);} }
        .loaderOverlay { position: fixed; inset: 0; background: #fff; display:flex; align-items:center; justify-content:center; z-index: 2000; transition: opacity .4s ease; }
        .loaderOverlay.hidden { opacity: 0; pointer-events: none; }
        .loaderLogo { width: 130px; height: 130px; animation: pulseLogo 1.6s ease-in-out infinite; }
      `}</style>
      <div className={`loaderOverlay ${appLoading ? '' : 'hidden'}`}>
        <img src={'/logo512.png'} alt="Loading" className="loaderLogo" />
      </div>
      <Router>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <AnnouncementBanner />
        <Box sx={{ flexGrow: 1 }}>
        <Routes>
            {/* Landing Page */}
            <Route 
              path="/" 
              element={
                <>
                  <Slideshow />
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, px: { xs: 2, md: 3 }, py: 2, maxWidth: 1400, mx: 'auto' }}>
                    <Box sx={{ flex: 1, minWidth: 0, order: { xs: 2, md: 1 } }}>
                      <PISection />
                      <ResearchInterests />
                      <OrganizationLogos />
                      <Divider sx={{ my: 2 }} />
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>Lab Life</Typography>
                        <PhotoGallery columns={3} />
                      </Box>
                    </Box>
                    <Box sx={{ flex: { md: '0 0 300px' }, order: { xs: 1, md: 2 } }}>
                      <AnnouncementsSidebar />
                    </Box>
                  </Box>
                </>
              } 
            />
            {/* Other Pages */}
            <Route path="/publications" element = {
              <React.Suspense fallback={<Box display="flex" justifyContent="center" py={4}><CircularProgress /></Box>}>
                <Pubpage/>
              </React.Suspense>
            } />
            <Route path="/software" element = {
              <React.Suspense fallback={<Box display="flex" justifyContent="center" py={4}><CircularProgress /></Box>}>
                <SoftwarePage/>
              </React.Suspense>
            }  />
            <Route path="/team" element = {
              <React.Suspense fallback={<Box display="flex" justifyContent="center" py={4}><CircularProgress /></Box>}>
                <BioGallery/>
              </React.Suspense>
            }/>
            <Route path="/join-us" 
            element={
              <Container maxWidth="sm" sx={{ py: 4, px: { xs: 2, md: 3 } }}>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, textAlign: 'center' }}>Join Us</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
                  Those interested in joining our group should apply directly to the department.
                </Typography>
                <Typography variant="body2" sx={{ textAlign: 'center' }}>
                  <ExternalLink href="https://www.uvic.ca/science/math-statistics/future-students/graduate/admission-checklist/index.php">
                    View application instructions
                  </ExternalLink>
                </Typography>
              </Container>
            }
            />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </Router>
    </>
  );
}

export default App;
